import { DatePicker } from '@mui/x-date-pickers';

type Props = {
  startDate: Date | null;
  setStartDate: (date: Date | null) => void;
  endDate: Date | null;
  setEndDate: (date: Date | null) => void;
};

const DATEPICKER_FORMAT = 'dd-MM-yyyy';

export function DateRangePickers({ startDate, setStartDate, endDate, setEndDate }: Props) {
  return (
    <>
      <DatePicker
        label="Start Date"
        value={startDate}
        onChange={setStartDate}
        format={DATEPICKER_FORMAT}
        slotProps={{
          field: { clearable: true },
          openPickerButton: { id: 'start_datepicker_open_calendar_button' },
          clearButton: { id: 'start_datepicker_clear_button' },
        }}
        maxDate={endDate ?? undefined}
        disableFuture={true}
        sx={{ flex: 1 }}
      />
      <DatePicker
        label="End Date"
        value={endDate}
        onChange={setEndDate}
        format={DATEPICKER_FORMAT}
        slotProps={{
          field: { clearable: true },
          openPickerButton: { id: 'end_datepicker_open_calendar_button' },
          clearButton: { id: 'end_datepicker_clear_button' },
        }}
        minDate={startDate ?? undefined}
        disableFuture={true}
        sx={{ flex: 1 }}
      />
    </>
  );
}
